import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getTipoUbicacion, createTipoUbicacion, updateTipoUbicacionById, deleteTipoUbicacionById } from "../api";

const FilterTableTipoUbicacion = () => {
  const [tipoUbicacion, setTipoUbicacion] = useState([]);
  const [filteredTipoUbicacion, setFilteredTipoUbicacion] = useState([]);
  const [formData, setFormData] = useState({ id: 0, descripcion: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

  const fetchTipoUbicacion = async () => {
    try {
      const response = await getTipoUbicacion();
      setTipoUbicacion(response.data);
      setFilteredTipoUbicacion(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching tipo ubicacion:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchTipoUbicacion();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = tipoUbicacion.filter((tipoUbicacion) =>
        tipoUbicacion.descripcion.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredTipoUbicacion(filtered);
    } else {
      setFilteredTipoUbicacion(tipoUbicacion);
    }
  }, [filterText, tipoUbicacion]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateTipoUbicacionById(formData.id, { descripcion: formData.descripcion });
        alert("Tipo de Ubicacion actualizado con éxito.");
      } else {
        await createTipoUbicacion(formData);
        alert("Tipo de Ubicacion registrado con éxito.");
      }
      setFormData({ id: 0, descripcion: "" });
      setIsEditing(false);
      fetchTipoUbicacion();
    } catch (error) {
      console.error("Error procesando el tipo de ubicacion:", error);
    }
  };

  const handleEdit = (tipoUbicacion) => {
    setFormData(tipoUbicacion);
    setIsEditing(true);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, descripcion: "" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar este tipo de ubicacion?")) {
      try {
        await deleteTipoUbicacionById(id);
        alert("Tipo de Ubicacion eliminado con éxito.");
        fetchTipoUbicacion();
      } catch (error) {
        console.error("Error eliminando el tipo de ubicacion:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Tipo de Ubicacion" : "Agregar Tipo de Ubicacion"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label3">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className="input-form-2"
          />
        </div>
        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por descripción..."
          className="input2"
        />
      </div>
      {filteredTipoUbicacion.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descripción</th>
              <th colSpan="2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredTipoUbicacion.map((tipoUbicacion) => (
              <tr key={tipoUbicacion.id}>
                <td>{tipoUbicacion.id}</td>
                <td>{tipoUbicacion.descripcion}</td>
                <td>
                  <button onClick={() => handleEdit(tipoUbicacion)} className="button-table-blue">
                    Editar
                  </button>
                </td><td>
                  <button onClick={() => handleDelete(tipoUbicacion.id)} className="button-table-red">
                    Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableTipoUbicacion.propTypes = {
  tipo_ubicacion: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableTipoUbicacion;
